export const I18N = {
    de: {
        monthLabels: {
            1: 'Januar',
            2: 'Februar',
            3: 'März',
            4: 'April',
            5: 'Mai',
            6: 'Juni',
            7: 'Juli',
            8: 'August',
            9: 'September',
            10: 'Oktober',
            11: 'November',
            12: 'Dezember'
        },
        dayLabels: { su: 'So', mo: 'Mo', tu: 'Di', we: 'Mi', th: 'Do', fr: 'Fr', sa: 'Sa' },
        dateFormat: 'dd.mm.yyyy',
        displayDateFormat: 'dd.MM.yyyy',
        placeholder: 'TT.MM.JJJJ'
    },
    en: {
        monthLabels: {
            1: 'January',
            2: 'February',
            3: 'March',
            4: 'April',
            5: 'May',
            6: 'June',
            7: 'July',
            8: 'August',
            9: 'September',
            10: 'October',
            11: 'November',
            12: 'December'
        },
        dayLabels: { su: 'Sun', mo: 'Mon', tu: 'Tue', we: 'Wed', th: 'Thu', fr: 'Fri', sa: 'Sat' },
        dateFormat: 'mm/dd/yyyy',
        displayDateFormat: 'MM/dd/yyyy',
        placeholder: 'MM/DD/YYYY'
    }
};
